module.exports = __webpack_public_path__ + "img/installation_quotes.3941ee37.png";